export default __webpack_public_path__ + "static/media/info-colored-icon.df3d4a65.svg";